import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LocalizedLandingPages from './pages/localized-landing-pages';
import DebtFreedomCalculator from './pages/debt-freedom-calculator';
import MoneyDurationCalculator from './pages/money-duration-calculator';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* English routes (default) */}
        <Route path="/" element={<LocalizedLandingPages />} />
        <Route path="/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* Spanish routes */}
        <Route path="/es" element={<LocalizedLandingPages />} />
        <Route path="/es/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/es/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* Portuguese routes */}
        <Route path="/pt" element={<LocalizedLandingPages />} />
        <Route path="/pt/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/pt/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* French routes */}
        <Route path="/fr" element={<LocalizedLandingPages />} />
        <Route path="/fr/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/fr/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* German routes */}
        <Route path="/de" element={<LocalizedLandingPages />} />
        <Route path="/de/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/de/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* Italian routes */}
        <Route path="/it" element={<LocalizedLandingPages />} />
        <Route path="/it/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/it/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* Dutch routes */}
        <Route path="/nl" element={<LocalizedLandingPages />} />
        <Route path="/nl/debt-freedom-calculator" element={<DebtFreedomCalculator />} />
        <Route path="/nl/money-duration-calculator" element={<MoneyDurationCalculator />} />
        
        {/* Legacy route */}
        <Route path="/localized-landing-pages" element={<LocalizedLandingPages />} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
